import './App.css';
import Navigation from './navigation/Navigation';
import WhatspButton from './Components/WhatspButton';


function App() {
  return (
   <>
   <WhatspButton/>
   <Navigation/>
   </>
  );
}

export default App;
